import { Label } from "@radix-ui/react-label";
import { InputText } from "primereact/inputtext";
import React from "react";
import { SectionTitle } from "../EmployeeForm";

function BankDetail({ formData, handleOnChange }) {
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Bank Details</SectionTitle>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 w-full">
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            Bank Account Number <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.bankAccountNumber}
            onChange={(e) =>
              handleOnChange("bankAccountNumber", e.target.value)
            }
            placeholder="Account Number"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            Bank Name <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.bankName}
            onChange={(e) => handleOnChange("bankName", e.target.value)}
            placeholder="Bank Name"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            IFSC Code <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.ifscCode}
            onChange={(e) => handleOnChange("ifscCode", e.target.value)}
            placeholder="IFSC Code"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            Bank Holder Name <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.bankHolderName}
            onChange={(e) => handleOnChange("bankHolderName", e.target.value)}
            placeholder="Holder Name"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">SWIFT Code</Label>
          <InputText
            value={formData.swiftCode}
            onChange={(e) => handleOnChange("swiftCode", e.target.value)}
            placeholder="SWIFT Code"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
      </div>
    </section>
  );
}

export default BankDetail;
